module.exports = __webpack_public_path__ + "static/concrete-patios-f77d7179749c36b83dd94c022849118b.jpg";